export function widgetTypesReducer(PRELOAD) {
    const initial = Object.keys(PRELOAD.widget_types ?? {});
    return (state = initial) => state;
}
